import { usePath } from '@apeiron/ui'
import { Box, Breakpoint, styled, useMediaQuery } from '@mui/material'
import ApeironBackButton from '@src/components/share/apeiron/ApeironBackButton'
import ApeironSticky from '@src/components/share/apeiron/ApeironSticky'
import { WhiteList } from '@src/constants/page'
import theme from '@src/styles/theme'
import { FC, ReactNode } from 'react'

const DesktopContainer = styled(ApeironSticky)`
  align-self: flex-start;
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  width: 408px;
`

const MobileContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  width: 100%;
`

const BackButton = styled(ApeironBackButton)`
  align-self: flex-start;
  margin-bottom: 5px;
  margin-left: -10px;
`

const ApeironSideDetail: FC<Props> = props => {
  const { breakpoint = 'res1280', cardView, className } = props

  const { noHeader } = usePath(WhiteList)

  const isMobile = useMediaQuery(theme.breakpoints.down(breakpoint))

  const Container = isMobile ? MobileContainer : DesktopContainer

  return (
    <Container className={className} bottom={20} top={noHeader ? 130 : 70}>
      <BackButton />
      {cardView}
    </Container>
  )
}

type Props = {
  breakpoint?: Breakpoint
  cardView?: ReactNode
  className?: string
}

export default ApeironSideDetail
